import React from 'react';
import Routes from './routes/Routes';
import './App.css';

function App() {
  return (
    <Routes />
  );
}

export default App;
